import Vue from 'vue'
import Printer from './components/Printer'

const PrinterApp = Vue.extend(Printer)

const printer = new PrinterApp({})

printer.$mount('#printer')

export default printer